import React, { useState } from "react";
import { Modal, Col } from "reactstrap";
import { CustomButton } from "../home/main/home-layout-draggable-columns/custom-button";
import { useTranslation } from "react-i18next";
import WarningIcon from "./items/WarningIcon";

export const ModalWelcome = ({   isOpen,
  onClose,
  onConfirm }) => {
  const { t } = useTranslation();
  const [name, setName] = useState(''); 
  
  const isValidEmail = (email) => {
    // Basic email pattern; avoids false positives while remaining permissive
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    return pattern.test(String(email).toLowerCase());
  };

  // Handle input changes
  const handleInputChange = (event) => {
    setName(event.target.value);
  };

   // Handle save
   const handleSave = () => {
    if (!isValidEmail(name)) {
      return;
    }
    onConfirm(name); // Pass the input value back to the parent
    setName(''); // Reset the input value
  };

  return (    
    <Modal isOpen={isOpen} className="modal-dialog-centered transitionSelector preview modalWelcome isOpen">
        <section>
      <div className="modal__container">      
        <div className="modal__title_welcome">{t("homeModalWelcome.title")}</div>
        <div className="modal__title_enter_email">{t("homeModalWelcome.titleEmail")}</div>
        <div className="d-flex justify-content-center">
         <input
              className="input"
              type="email"
              value={name}
              onChange={handleInputChange} // Handle input changes
            />
        </div>
        
        <div className="modal__buttons">
        <button
              type="button"
              className="close__button modal-button cancel-button"
              onClick={onClose}
            >
              {t("homeModalWelcome.buttonNo")}
            </button>
            <button
              type="button"
              className="close__button modal-button save-button"
              onClick={handleSave}
              disabled={!isValidEmail(name)}
            >
              {t("homeModalWelcome.buttonYes")}
            </button>
        </div>
      </div>
    </section>
      
    </Modal>
);
};